module.exports = __webpack_public_path__ + "public/SiteImages/editDarkBg.svg?4dfda03f";